import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/ai/model/page`
  return http.post(url, params)
}
// 获取 详情
const getAction = (params) => {
  const url = `/market/ai/model/detail`
  return http.post(url, params)
}
// 新建
const addAction = (params) => {
  const url = `/market/ai/model/save`
  return http.post(url, params)
}
// 发送测试邮件
const bindAction=(params)=>{
  const url = `/market/ai/model/api/list`
  return http.post(url,params)
}
// 修改禁用启用
const statusAction = (params) => {
  const url = `/market/ai/model/status`
  return http.post(url, params)
}

export default {
  searchAction,
  getAction,
  addAction,
  bindAction,
  statusAction
}
